/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Skeleton, Typography, Typography2, breakpoints } from '@coursera/cds-core';

const styles = {
  imgWrapper: () => css`
    height: 112px;
    width: 112px;

    ${breakpoints.down('xs')} {
      height: 60px;
      width: 60px;
    }
  `,
  locationText: () => css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const ProfileSkeletonLoader = () => {
  return (
    <>
      <div css={styles.imgWrapper} data-testid="profile-photo-invite-section-loader">
        <Skeleton variant="circle" width="100%" height="100%" />
      </div>
      <Typography variant="h1semibold" component="span">
        <Skeleton width={180} />
      </Typography>
      <Typography2 variant="subtitleMedium" component="span">
        <Skeleton width={50} />
      </Typography2>
      <div css={styles.locationText}>
        <Typography2 component="p" variant="bodyPrimary">
          <Skeleton width={170} />
        </Typography2>
      </div>
      <Skeleton width={165} height={80} />
    </>
  );
};

export default ProfileSkeletonLoader;
